import { render } from "./18_SF6.vue?vue&type=template&id=b7845a86"
import script from "./18_SF6.vue?vue&type=script&lang=js"
export * from "./18_SF6.vue?vue&type=script&lang=js"
script.render = render

export default script